export const typeMap = {
  0: 'Vuelos',
  1: 'Alojamiento',
  2: 'Paquetes',
  3: 'Assit Card',
};
